<template>
  <div>
    <div v-if="logsWithNotes.length > 0">
      <div class="notes-row" v-for="log in logsWithNotes" :key="log.created">
        <div class="notes-row-header">
          <div>
            <template
              v-if="
                (log.type && log.type === 'note') ||
                  (!log.userBasal && !log.basaDose && !log.bolusUser)
              "
            >
              <v-chip class="ma-2" color="#1b1f40" dark label>
                <v-icon left>mdi-text</v-icon>
                Note log
              </v-chip>
            </template>
            <template v-else-if="log.userBasal && log.basaDose">
              <v-chip class="ma-2" color="#335a2a" dark label>
                <v-icon left>mdi-opacity</v-icon>
                Basal log
              </v-chip>
            </template>
            <template v-else-if="log.mode === 'only_corr'">
              <v-chip class="ma-2" color="#f6b037" dark label>
                <v-icon left>mdi-opacity</v-icon>
                Correction Bolus
              </v-chip>
            </template>
            <template v-else>
              <v-chip class="ma-2" color="#74b766" dark label>
                <v-icon left>mdi-opacity</v-icon>
                Meal Bolus
              </v-chip>
            </template>

            <template v-if="log.override && log.override === true">
              <v-chip class="ma-2" color="#a13431" dark label>
                <v-icon left>mdi-error</v-icon>
                Override
              </v-chip>
            </template>
          </div>
          <div class="caption">
            {{ log.timestamp | moment("MMMM DD, HH:mm") }}
          </div>
        </div>
        <div class="notes-row-content body-1" v-if="log.bg">
          <v-chip class="my-2" small label>Blood Glucose</v-chip>
          {{ log.bg }} mmol/L
        </div>
        <div class="notes-row-content body-1">{{ log.notes }}</div>
      </div>
    </div>
    <div v-else class="body-1">
      There are no notes for the selected week.
    </div>
  </div>
</template>

<style scoped>
.notes-row {
  margin-top: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 10px;
}
.notes-row .notes-row-header {
  font-size: 0.8em;
  display: flex;
  justify-content: space-between;
}
.notes-row .notes-row-content {
  margin-left: 10px;
}
</style>

<script>
export default {
  name: "participant-notes",
  props: ["logs"],
  computed: {
    logsWithNotes: function() {
      return this.logs.filter(log => log.notes && log.notes != "").reverse();
    }
  }
};
</script>
